import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5gcihcbntu: FaireBrandEntity = {
  token: "b_5gcihcbntu",
  type: "brand",
  name: "Boheme Fragrances",
  avatarUrl:
    "https://cdn.faire.com/fastly/e2a12e4d97935efbf1d0bebc2e55bdd417fcaf0ecdf7a146c0e5b695f9193cfb.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e8074a441e66db6c2696925a066a8ba8fdade449f588ac801d63465267fba8a2.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e2a12e4d97935efbf1d0bebc2e55bdd417fcaf0ecdf7a146c0e5b695f9193cfb.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e8074a441e66db6c2696925a066a8ba8fdade449f588ac801d63465267fba8a2.png",
  location: "Atlanta, GA, USA",
  minimumOrderDollars: 99,
  rating: 4.9,
  reviewCount: 84,
  isInsider: true,
  description:
    "Boheme is a sensory journey—a collection of fragrances inspired by the quiet beauty of faraway places, fleeting moments, and the sacred art of slowing down.\n\nBorn from a deep reverence for travel, ritual, and storytelling, each Boheme scent captures the spirit of a destination—not just in geography, but in feeling. From the meditative forests of Ubud to the coastal air of Cape Town, the spice-laced evenings of Fez to the misty serenity of Kyoto, our fragrances invite you to experience the world through scent: intimately, intentionally, and beyond category.\n\nWe believe fragrance is a ritual for the curious. A way to anchor memory, emotion, and presence. Designed for those who move through the world with wonder, Boheme is soulful, refined, and grounded in simplicity. Each product is crafted with thoughtful formulation and clean ingredients—made to elevate everyday rituals and create space for stillness.\n\nThis is fragrance for the modern wanderer. For those who crave meaning, not excess. Depth, not noise.\n\nA life well-scented. A soul well-traveled.\nWelcome to Boheme.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:21.315Z",
    importedBy: "entity-db-cli",
  },
};
